"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ring = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Ring({ color = '#7f58af', size = 80, className, style, }) {
    const circles = [...Array(4)].map((_, index) => {
        return ((0, jsx_runtime_1.jsx)("div", { style: {
                borderColor: `${color} transparent transparent transparent`,
                width: size * 0.8,
                height: size * 0.8,
                margin: size * 0.1,
                borderWidth: size * 0.1,
            } }, index));
    });
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-ring'], className), style: { width: size, height: size, ...style }, children: circles }));
}
exports.Ring = Ring;
//# sourceMappingURL=ring.js.map